import React, { useEffect } from "react";
import { FormattedMessage, useIntl } from "react-intl";
import { useNavigate } from "react-router";
import { useLogout } from "@/ubisoft/uplay";
import { AccessSteps } from "./AccessSteps";
import { IconTheme, TextIconButton } from "@/components/IconButton/IconButton";
import styles from "./Login.module.scss";
import { metrics } from "../../analytics/events";
import { CONFIG } from "../../config";
export function NoArtbook() {
    var intl = useIntl();
    var navigate = useNavigate();
    var logout = useLogout();
    useEffect(function () {
        metrics.noAccessPageDisplayed();
    }, []);
    var onLogout = function () {
        metrics.clickOnLogout();
        logout();
        navigate("..");
    };
    return (React.createElement("div", { className: styles.loginPage },
        React.createElement("h2", { className: styles.header },
            React.createElement(FormattedMessage, { defaultMessage: "Digital artbook & soundtrack", id: "jCTuVI", tagName: "span" })),
        React.createElement("div", { className: styles.panel },
            React.createElement("p", { className: styles.steps },
                React.createElement(FormattedMessage, { defaultMessage: "We were unable to fulfill your request. To access the content, please make sure that you have followed all those steps:", id: "4w4pbP", tagName: "b" }),
                React.createElement(AccessSteps, null)),
            React.createElement("div", { className: styles.actions },
                CONFIG.buyButtonEnabled ? (React.createElement("div", { className: styles.row },
                    React.createElement(TextIconButton, { theme: IconTheme.Dark, className: styles.loginButton, center: true, target: "_blank", href: intl.formatMessage({
                            defaultMessage: "https://store.ubisoft.com/62ea4b5609372571f2736a6b.html",
                            id: "XxY1AR",
                            description: "buy_game_no_artbook",
                        }), onClick: function () { return metrics.clickOnGetYourEdition(); } },
                        React.createElement(FormattedMessage, { defaultMessage: "Buy now on PC", id: "Sf3EcF" })),
                    React.createElement(TextIconButton, { theme: IconTheme.Dark, className: styles.loginButton, center: true, target: "_blank", href: intl.formatMessage({
                            defaultMessage: "mailto:support@ubisoft.com",
                            id: "OUUMz+",
                        }), onClick: function () {
                            metrics.clickOnContactSupport();
                        } },
                        React.createElement(FormattedMessage, { defaultMessage: "Contact support", id: "5CI3KH" })))) : (React.createElement(TextIconButton, { theme: IconTheme.Dark, className: styles.loginButton, target: "_blank", href: intl.formatMessage({
                        defaultMessage: "mailto:support@ubisoft.com",
                        id: "OUUMz+",
                    }), onClick: function () {
                        metrics.clickOnContactSupport();
                    } },
                    React.createElement(FormattedMessage, { defaultMessage: "Contact support", id: "5CI3KH" }))),
                React.createElement(TextIconButton, { theme: IconTheme.Dark, className: styles.loginButton, onClick: onLogout },
                    React.createElement(FormattedMessage, { defaultMessage: "Log out", id: "PlBReU" }),
                    React.createElement("img", { src: require("@/public_assets/icon_exit.png"), style: { height: "25px" } }))))));
}
